import ContentBelow from "../components/ContentBelow";
import Head from "../components/Head";
import classes from "../components/Contact.module.css";
import background from "../images/services_background.png";
import mapImg from "../images/map-marked-alt.png";
import { useState } from "react";
import contactUS01 from "../images/ContactUs-01.png";
import { Link } from "react-router-dom";

function Contact() {
  const cards = [
    {
      title: "PRETORIA",
      address: "75 Durham Rd, Centurion, 0157",
      icon: "map",
      link: "https://cboffices.co.za/",
    },
    {
      title: "GEORGE",
      address: "126 York Street, George, 6530",
      icon: "map",
    },
    {
      title: "WhatsApp",
      contact: "+27 63 068 0075",
      icon: "whatsapp",
    },
    {
      title: "Phone",
      contact: "012 941 9544",
      icon: "headset",
    },
    {
      title: "Email",
      contact: "apply@webridge.co.za",
      icon: "envelope",
    },
  ];

  function CardView({ card }) {
    return (
      <>
        {card.link ? (
          <Link to={card.link}>
            <div
              className={`card w-100 text-center p-3 h-100 `}
              style={{ backgroundColor: "#113358", color: "#fff" }}
            >
              <div className="container-fluid text-center p-2">
                {card.icon ? (
                  <i className={`bi bi-${card.icon} ${classes.svg}`}></i>
                ) : (
                  <img src={mapImg} width={70} alt="..." />
                )}
              </div>

              <div className={`card-body`}>
                <h5 className="card-title">{card.title}</h5>

                {card.address ? (
                  <p className="card-text">{card.address}</p>
                ) : (
                  <p className="card-text">{card.contact}</p>
                )}
              </div>
            </div>
          </Link>
        ) : (
          <div
            className={`card w-100 text-center p-3 h-100 `}
            style={{ backgroundColor: "#113358", color: "#fff" }}
          >
            <div className="container-fluid text-center p-2">
              {card.icon ? (
                <i className={`bi bi-${card.icon} ${classes.svg}`}></i>
              ) : (
                <img src={mapImg} width={70} alt="..." />
              )}
            </div>

            <div className={`card-body`}>
              <h5 className="card-title">{card.title}</h5>

              {card.address ? (
                <p className="card-text">{card.address}</p>
              ) : (
                <p className="card-text">{card.contact}</p>
              )}
            </div>
          </div>
        )}
      </>
    );
  }

  return (
    <>
      <Head imageUrl={background}>
        <h2 className="heading_space">Contact Us</h2>
      </Head>
      <div className={classes.whiteDiv}>
        <div>
          <p className="text-center p-3 m-3">
            Use the details below to reach us, or alternatively apply for
            bridging finance through the online form
          </p>
        </div>
        <div className="container">
          <div className="row g-4 justify-content-center">
            {cards.map((card, index) => (
              <div className="col-lg-2 col-md-3 col-sm-3">
                <CardView card={card} />
              </div>
            ))}
          </div>
          <div>
            <img src={contactUS01} alt="" width="500" />
          </div>
        </div>
      </div>
    </>
  );
}
export default Contact;
